// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCwTamV-I_OhYfAmDyLJT_RzzHAgWv2k7E",
  authDomain: "ticketmanagement-a2f0e.firebaseapp.com",
  projectId: "ticketmanagement-a2f0e",
  storageBucket: "ticketmanagement-a2f0e.firebasestorage.app",
  messagingSenderId: "1074127802744",
  appId: "1:1074127802744:web:b03eebafc6a75b2cd2f88d",
  measurementId: "G-F6MHY6KR9H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Firestore instance
export const db = getFirestore(app);
